import React, { useState, useEffect, useRef } from 'react';
import styles from './LoreQuote.module.css';

const QUOTES = [
  {
    text: 'In the world of Aden, there are those who seek power, those who seek glory, and those who seek truth. Most find only war.',
    source: 'Chronicle of Aden',
  },
  {
    text: 'A castle won by a single warrior means nothing. A castle won by a clan means everything.',
    source: 'The Art of Siege',
  },
  {
    text: 'The gods abandoned Aden long ago. What remains is ours to shape - through blade, through spell, through brotherhood.',
    source: 'Tablets of the Dark Elves',
  },
  {
    text: 'Adena flows like blood in Aden. Lose too much of either and you will not survive the week.',
    source: 'A Dwarf Merchant of Giran',
  },
  {
    text: 'No wall is unbreakable. No clan is undefeatable. No legend is permanent - until it is written by those who refuse to be forgotten.',
    source: 'Inscription at Goddard Castle',
  },
  {
    text: 'The strongest players are not those with the best gear. They are those who remember why they first entered these lands.',
    source: 'Words of a Returning Veteran',
  },
];

const INTERVAL = 6000;

export default function LoreQuote() {
  const [index, setIndex] = useState(0);
  const [fading, setFading] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setIndex(i => (i + 1) % QUOTES.length);
        setFading(false);
      }, 500);
    }, INTERVAL);
    return () => clearInterval(timerRef.current);
  }, []);

  const { text, source } = QUOTES[index];

  return (
    <aside className={styles.wrapper} aria-label="Lore quote">
      <div className={styles.ornamentLeft} aria-hidden="true" />
      <div className={`${styles.content} ${fading ? styles.fading : ''}`}>
        <blockquote className={styles.quote}>"{text}"</blockquote>
        <cite className={styles.source}>- {source}</cite>
      </div>
      <div className={styles.ornamentRight} aria-hidden="true" />
    </aside>
  );
}
